import { useEffect, useState } from "react";
import { api, API_BASE } from "@/lib/api";
import { PaintBrush, ArrowSquareOut } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

function tokenHeaders() {
  const t = localStorage.getItem("aig_access_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

const DESCRIPTIONS = {
  classic: "Timeless black header, framed with a rule. Confident and traditional.",
  minimal: "Wide margins, muted headings. Best for premium services.",
  corporate: "Solid navy header band. Formal, IT/consulting look.",
  modern: "Bold red accent line + heading — retail, agencies.",
  elegant: "Serif type, centred header. Boutique / hospitality.",
  compact: "Dense layout — many invoices per period.",
  professional_blue: "Deep blue bar header. Finance, legal.",
  monochrome: "Black block over white. Studios, minimalist brands.",
};

export default function TemplatesPage() {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");

  useEffect(() => {
    api.get("/templates").then((r) => {
      setTemplates(r.data);
      if (r.data.length && !selected) setSelected(r.data[0].code);
    });
    /* eslint-disable-next-line */
  }, []);

  useEffect(() => {
    if (!selected) return;
    let url = "";
    fetch(`${API_BASE}/templates/${selected}/preview`, { credentials: "include", headers: tokenHeaders() })
      .then((r) => r.blob())
      .then((blob) => {
        url = URL.createObjectURL(blob);
        setPdfUrl(url);
      });
    return () => url && URL.revokeObjectURL(url);
  }, [selected]);

  return (
    <div className="p-8 space-y-6">
      <div>
        <h1 className="font-display text-3xl font-bold text-slate-900">Invoice Templates</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Eight professionally-styled A4 templates. Each party is permanently assigned exactly one.
        </p>
      </div>

      <div className="grid lg:grid-cols-[280px_1fr] gap-6">
        <div className="space-y-2">
          {templates.map((t) => (
            <button
              key={t.code}
              onClick={() => setSelected(t.code)}
              data-testid={`template-${t.code}`}
              className={`w-full text-left p-3 rounded-md border transition-all ${
                selected === t.code
                  ? "border-primary bg-primary/5"
                  : "border-border hover:border-primary/40"
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="font-display font-medium flex items-center gap-2">
                  <PaintBrush size={16} weight="duotone" /> {t.name}
                </div>
                <span className="text-[10px] uppercase tracking-wider text-muted-foreground">{t.code}</span>
              </div>
              <div className="text-xs text-muted-foreground mt-1">{DESCRIPTIONS[t.code]}</div>
            </button>
          ))}
        </div>

        <div className="card-panel">
          <div className="p-3 border-b border-border flex items-center justify-between">
            <div className="font-medium">Live preview</div>
            {pdfUrl && <Button size="sm" variant="ghost" onClick={() => window.open(pdfUrl, "_blank")}><ArrowSquareOut size={14} className="mr-1" />Open in new tab</Button>}
          </div>
          <div style={{ height: "800px" }}>
            {pdfUrl ? (
              <iframe title="preview" src={pdfUrl} className="w-full h-full" data-testid="template-preview-iframe" />
            ) : (
              <div className="h-full grid place-items-center text-muted-foreground text-sm">Loading preview…</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
